// extracted by mini-css-extract-plugin
export default {"wrapper":"AC","noPadding":"BC","flavor_wrapper":"CC","flavor_button":"EC","vert":"FC","itemContent":"GC","itemName":"HC","blue":"IC","out_of_stock":"JC","newFlavorBadge":"KC","fullWidth":"LC","flavor_button_selected":"MC","black":"NC","attribute_wrapper":"OC","toggle_wrapper":"PC"};
    if(module.hot) {
      // 1738836196795
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  